export enum EArchiveState {
  Active = 'Active',
  Archived = 'Archived',
  ArchivedForDeletion = 'ArchivedForDeletion',
}
